import { Air, CloudQueue } from '@mui/icons-material';
import { MeasurementData } from 'features/weather/types';

interface Props {
  condition: MeasurementData;
  warning: boolean;
}

const WeatherAlertIcon = ({ condition, warning }: Props) => {
  if (condition === 'wind_kph' || condition === 'gust_kph')
    return <Air sx={{ color: warning ? 'red' : 'orange' }} />;
  if (condition === 'cloud_percent')
    return <CloudQueue sx={{ color: warning ? 'red' : 'orange' }} />;
  if (condition === 'precip_mm')
    return (
      <img
        height='20'
        src='/raindrops-svgrepo-com.svg'
        alt='raindrops'
        style={{
          filter: warning
            ? 'invert(24%) sepia(96%) saturate(5086%) hue-rotate(354deg) brightness(89%) contrast(129%)'
            : 'invert(70%) sepia(47%) saturate(3380%) hue-rotate(359deg) brightness(102%) contrast(107%)',
        }}
      />
    );
  return null;
};

export default WeatherAlertIcon;
